<template>
  <div
    class="html-container"
    :style="{ color: textDefaultColor }"
    v-html="html"
  />
</template>

<script>
export default {
  props: {
    html: {
      type: String,
      default: ''
    },
    textDefaultColor: {
      type: String,
      default: '#333'
    }
  }
}
</script>

<style scoped lang="scss">
.html-container::v-deep {
  h1 {
    margin-bottom: 12px;
  }

  h2 {
    margin-bottom: 8px;
  }

  h3 {
    margin-bottom: 4px;
  }

  a {
    font-weight: 600;
  }

  p {
  }

  strong {
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 8px auto;

    tr {
    }

    th {
      border: solid 1px black;
    }

    td {
      text-align: center;
      border: solid 1px black;
    }
  }
}
</style>
